import React from "react";
import AboutUsPageContent from "../components/AboutUs";

const AboutUs = () => {
  return (
    <div>
      <AboutUsPageContent />
    </div>
  );
};

export default AboutUs;
